/** Human text for asks and models, shared by Now, Inbox, push details and the mock hub. */
import type { TranscriptEvent } from '@viko/protocol'
import { modelLabel } from '@viko/transcript-ui'

export function askSummary(e: TranscriptEvent): string {
  if (e.kind === 'question') return e.questions[0]?.question ?? 'Question'
  if (e.kind !== 'approval') return ''
  if (e.title && e.title !== e.toolName) return e.title
  if (e.approvalKind === 'plan') return 'Approve the plan before it starts editing'
  const input = (e.input ?? {}) as Record<string, unknown>
  const cmd = e.command ?? (typeof input.command === 'string' ? input.command : undefined)
  if (cmd) return `Run \`${oneLine(cmd, 80)}\``
  const path =
    typeof input.file_path === 'string'
      ? input.file_path
      : typeof input.path === 'string'
        ? input.path
        : undefined
  if (path)
    return `${e.toolName === 'Write' ? 'Create' : 'Edit'} ${path.split('/').slice(-2).join('/')}`
  if (typeof input.url === 'string') return `Fetch ${input.url}`
  if (e.approvalKind === 'file_change') return 'Apply file changes'
  return `Allow ${e.toolName ?? 'tool'}`
}

function oneLine(s: string, max: number) {
  const t = s.replace(/\s+/g, ' ').trim()
  return t.length > max ? `${t.slice(0, max - 1)}…` : t
}

/** claude-haiku-4-5-20251001 → Haiku 4.5; claude-opus-5-5[1m] → Opus 5.5 · 1M. */
export function modelName(id: string | undefined): string | undefined {
  return modelLabel(id)
}

/** "in 45 min" / "in 5h 12m" / "in 5d 7h" — compact countdown to a reset. */
export function resetCountdown(resetsAt: number, now: number): string {
  const ms = resetsAt - now
  if (ms <= 0) return 'now'
  const min = Math.ceil(ms / 60_000)
  if (min < 60) return `in ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `in ${h}h${min % 60 ? ` ${min % 60}m` : ''}`
  const d = Math.floor(h / 24)
  return `in ${d}d${h % 24 ? ` ${h % 24}h` : ''}`
}
